<div class="ap-accordion__item">
    <h3
        class="ap-accordion__wrapper"
        [ngClass]="{
            'ap-heading-3 ap-heading-3--tertiary secondary': variant() === 'medium',
            'ap-heading-2 ap-heading-2--tertiary': variant() === 'large'
        }"
    >
        <button
            class="ap-accordion__heading"
            [class.ap-accordion__heading--empty]="isEmpty()"
            [id]="headingId"
            #heading
            type="button"
            [disabled]="isEmpty()"
            [attr.aria-expanded]="isOpen()"
            [attr.aria-disabled]="isEmpty() ? 'true' : null"
            [attr.aria-controls]="contentId"
            (click)="click()"
            [tabindex]="isEmpty() ? -1 : 0"
            data-testid="accordion-heading"
        >
            @if (iconName()) {
                <asn-icon
                    class="ap-accordion__icon"
                    [name]="iconName()"
                    color="inherit"
                    size="medium"
                    data-testid="accordion-icon"
                ></asn-icon>
            }
            <span class="ap-accordion__title-container" data-testid="accordion-title">
                {{ accordionItemTitle() }}
                @if (subTitle()) {
                    <span class="ap-accordion__sub-title" data-testid="accordion-subtitle">{{ subTitle() }}</span>
                }
            </span>

            @if (!isEmpty()) {
                <asn-icon
                    [name]="isOpen() ? 'chevron-up' : 'chevron-down'"
                    size="medium"
                    color="dark"
                    class="ap-accordion__indicator"
                    data-testid="accordion-icon-status"
                ></asn-icon>
            }
        </button>
    </h3>

    <!-- Accordion content gets displayed on print by css. Will break if the content is not in the DOM -->
    @if (isOpen()) {
        <section
            class="ap-accordion__content"
            [ngClass]="{ 'heading-has-icon': iconName() }"
            [id]="contentId"
            [attr.aria-labelledby]="headingId"
            data-testid="accordion-content"
        >
            <ng-content></ng-content>
        </section>
    }
</div>
